import styled from "styled-components";
import { Tooltip } from "antd";
import { Text } from "@lmc/ui-kit/src/general";
import { Avatar } from "@lmc/ui-kit";

export type AvatarsList = Array<{
    name: string;
    viewedOn: string;
    url?: string;
  }>

export type SeenByProps = {
  title?: string;
  avatars?: AvatarsList;
  seenByText?: string;
};

const SeenBy = ({ title, avatars = [], seenByText }: SeenByProps) => {
  return (
    <Container>
      {title && (
        <StyledTitleText level={1} weight="medium">
          {title}
        </StyledTitleText>
      )}

      {avatars.length > 0 && (
        <AvatarsContainer>
          {avatars.map((avatar, index) => (
            <Tooltip
              key={`avatar-${index}-${avatar.name}`}
              title={
                <TooltipContent>
                  <Avatar url={avatar.url} border={true} />
                  <TooltipInfo>
                    <StyledNameText level={1} weight="bold">
                      {avatar.name}
                    </StyledNameText>
                    <LightGreyStyledText level={2}>
                      {avatar.viewedOn}
                    </LightGreyStyledText>
                  </TooltipInfo>
                </TooltipContent>
              }
              color="white"
            >
              <Avatar url={avatar.url} border={true} hoverable={true} />
            </Tooltip>
          ))}
        </AvatarsContainer>
      )}

      {seenByText && (
        <LightGreyStyledText level={1.5}>{seenByText}</LightGreyStyledText>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const AvatarsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px;
`;

const TooltipInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const StyledNameText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color1};
`;

const LightGreyStyledText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`;

const StyledTitleText = styled(Text)`
  font-size: 18px;
  color: ${(props) => props.theme.color.neutral.color3};
`;

export default SeenBy;
